import React from 'react';
import { Container, Row, Col } from 'react-bootstrap';
import { Link, useParams, useNavigate } from 'react-router-dom';
import ScrollReveal from './ScrollReveal';
import Seo from './Seo';
import { getSolution } from '../solutions/data';

function SolutionDetail() {
    const { slug } = useParams();
    const navigate = useNavigate();
    const solution = getSolution(slug);

    if (!solution) {
        return (
            <main>
                <section className="site-section-lg">
                    <Container>
                        <Row className="justify-content-center text-center">
                            <Col lg={8}>
                                <h1 className="hero-headline mb-4">Solution not found</h1>
                                <Link to="/solutions" className="btn-primary-cta">Back to solutions</Link>
                            </Col>
                        </Row>
                    </Container>
                </section>
            </main>
        );
    }

    return (
        <main>
            <Seo
                title={`${solution.title} — Qcoda`}
                description={solution.summary}
                path={`/solutions/${solution.slug}`}
            />

            <section className="site-section-lg">
                <Container>
                    <Row className="justify-content-center">
                        <Col lg={10} xl={9}>
                            <ScrollReveal animation="fade-in">
                                <p style={{ fontSize: '0.85rem', color: 'rgba(120,170,240,0.9)', textTransform: 'uppercase', letterSpacing: '0.08em', marginBottom: '1rem' }}>
                                    <Link to="/solutions" style={{ color: 'inherit', textDecoration: 'none' }}>
                                        &larr; Solutions
                                    </Link>
                                    <span style={{ margin: '0 0.5rem', color: 'rgba(255,255,255,0.3)' }}>·</span>
                                    {solution.eyebrow}
                                </p>
                            </ScrollReveal>
                            <ScrollReveal animation="fade-up" delay={100}>
                                <h1 className="hero-headline mb-3">{solution.title}</h1>
                            </ScrollReveal>
                            <ScrollReveal animation="fade-up" delay={200}>
                                <p className="hero-sub mb-4">{solution.tagline}</p>
                            </ScrollReveal>
                            <ScrollReveal animation="fade-up" delay={300}>
                                <p className="section-subheading">{solution.summary}</p>
                            </ScrollReveal>
                        </Col>
                    </Row>
                </Container>
            </section>

            <hr className="section-divider" />

            <section className="site-section">
                <Container>
                    <Row className="justify-content-center">
                        <Col lg={9} xl={8}>
                            <ScrollReveal animation="fade-up">
                                <span className="eyebrow-lead">The problem</span>
                                <h2 className="section-heading mt-3 mb-4">Why it needs a governance layer</h2>
                                <p className="section-subheading">{solution.problem}</p>
                            </ScrollReveal>
                        </Col>
                    </Row>
                </Container>
            </section>

            <hr className="section-divider" />

            <section className="site-section">
                <Container>
                    <Row className="justify-content-center">
                        <Col lg={9} xl={8}>
                            <ScrollReveal animation="fade-up">
                                <span className="eyebrow-quiet">The Qcoda approach</span>
                                <h2 className="section-heading mt-3 mb-4">How Qcoda delivers it</h2>
                            </ScrollReveal>
                            <Row className="g-4">
                                {solution.approach.map((step, i) => (
                                    <Col md={6} key={i}>
                                        <ScrollReveal animation="fade-up" delay={i * 80} className="h-100">
                                            <div className="glass-card h-100">
                                                <p style={{ fontSize: '0.85rem', color: 'rgba(120,170,240,0.9)', marginBottom: '0.5rem', fontWeight: 600 }}>
                                                    Step {i + 1}
                                                </p>
                                                <p className="text-muted-white" style={{ margin: 0, lineHeight: 1.65 }}>{step}</p>
                                            </div>
                                        </ScrollReveal>
                                    </Col>
                                ))}
                            </Row>
                        </Col>
                    </Row>
                </Container>
            </section>

            <hr className="section-divider" />

            <section className="site-section">
                <Container>
                    <Row className="justify-content-center">
                        <Col lg={9} xl={8}>
                            <ScrollReveal animation="fade-up">
                                <span className="eyebrow-quiet">Outcomes</span>
                                <h2 className="section-heading mt-3 mb-4">What changes for your organization</h2>
                                <ul className="list-unstyled">
                                    {solution.outcomes.map((o, i) => (
                                        <li key={i} className="shipped-item">
                                            <span className="shipped-dot" />
                                            <span>{o}</span>
                                        </li>
                                    ))}
                                </ul>
                            </ScrollReveal>
                        </Col>
                    </Row>
                </Container>
            </section>

            <hr className="section-divider" />

            <section className="site-section">
                <Container>
                    <Row className="justify-content-center">
                        <Col lg={8}>
                            <ScrollReveal animation="scale-in">
                                <div className="glass-card-lg text-center">
                                    <span className="eyebrow-quiet">The alignment thread</span>
                                    <p className="section-subheading mt-3 mb-4" style={{ fontStyle: 'italic' }}>
                                        {solution.alignmentThread}
                                    </p>
                                    <button onClick={() => navigate('/contact')} className="btn-primary-cta">
                                        {solution.cta} &rarr;
                                    </button>
                                </div>
                            </ScrollReveal>
                        </Col>
                    </Row>
                </Container>
            </section>
        </main>
    );
}

export default SolutionDetail;
